import React from "react";
import { Link } from "wouter";

import { Markdown } from "../../../../components/src/Markdown";

import accountingLogic from "./AccountingLogic.md?raw";

export function AccountingLogicPage(): React.ReactElement {
    return (
        <div className="markdown-doc">
            <Link to="/accountingruns2">Accounting runs</Link>
            <Markdown markdown={accountingLogic} />
        </div>
    );
}
